export default __webpack_public_path__ + "static/undorm_image-43f0b25d494d4a111e77b132e7272a11.png";